import { index, pgTable, text, integer } from 'drizzle-orm/pg-core'
import { relations } from 'drizzle-orm'
import { getBaseFields, getBaseIndexes, getIdReference } from '../common/utils'
import { visits } from './visit'
import { users } from './user'

// Main feedback table
export const feedbacks = pgTable(
  'feedbacks',
  {
    ...getBaseFields(),
    visitId: getIdReference(() => visits.id),
    createdByUserId: getIdReference(() => users.id),
    ratingValue: integer().notNull(), // 1-5 stars
    description: text(),
  },
  (table) => [
    ...getBaseIndexes('feedbacks', table),
    index('feedbacks_visit_id_idx').on(table.visitId),
  ],
)

// Feedback tags table
export const feedbackTags = pgTable(
  'feedback_tags',
  {
    ...getBaseFields(),
    name: text().notNull().unique(),
    category: text(), // For grouping tags (e.g., "positive", "negative", "neutral")
  },
  (table) => getBaseIndexes('feedback_tags', table),
)

// Many-to-many junction table for feedback-tag relationships
export const feedbackTagMappings = pgTable(
  'feedback_tag_mappings',
  {
    ...getBaseFields(),
    feedbackId: getIdReference(() => feedbacks.id),
    feedbackTagId: getIdReference(() => feedbackTags.id),
  },
  (table) => [
    ...getBaseIndexes('feedback_tag_mappings', table),
    index('feedback_tag_mappings_feedback_id_idx').on(table.feedbackId),
  ],
)

// Relations
export const feedbacksRelations = relations(feedbacks, ({ one, many }) => ({
  visit: one(visits, {
    fields: [feedbacks.visitId],
    references: [visits.id],
  }),
  createdByUser: one(users, {
    fields: [feedbacks.createdByUserId],
    references: [users.id],
  }),
  feedbackTagMappings: many(feedbackTagMappings),
}))

export const feedbackTagsRelations = relations(feedbackTags, ({ many }) => ({
  feedbackTagMappings: many(feedbackTagMappings),
}))

export const feedbackTagMappingsRelations = relations(
  feedbackTagMappings,
  ({ one }) => ({
    feedback: one(feedbacks, {
      fields: [feedbackTagMappings.feedbackId],
      references: [feedbacks.id],
    }),
    feedbackTag: one(feedbackTags, {
      fields: [feedbackTagMappings.feedbackTagId],
      references: [feedbackTags.id],
    }),
  }),
)
